var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNorway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 39.9999C31.0461 39.9999 40.0004 31.0456 40.0004 19.9999C40.0004 8.95421 31.0461 -9.15527e-05 20.0004 -9.15527e-05C8.95467 -9.15527e-05 0.000366211 8.95421 0.000366211 19.9999C0.000366211 31.0456 8.95467 39.9999 20.0004 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.689148 25.2174C1.84634 29.5111 4.39673 33.2325 7.82626 35.8676V25.2174H0.689148Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.261 39.9239C18.8343 39.9733 19.4141 40 20.0002 40C29.2407 40 37.0162 33.7327 39.3112 25.2174H18.261V39.9239Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3112 14.7826C37.0162 6.26726 29.2407 0 20.0002 0C19.4141 0 18.8343 0.0267187 18.261 0.0760937V14.7826H39.3112Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82626 4.13245C4.39673 6.7676 1.84634 10.4889 0.689148 14.7826H7.82626V4.13245Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8307 17.3913H15.6523H15.6522V0.475372C13.8039 0.885216 12.0516 1.54951 10.4348 2.43178V17.3912V17.3912H0.169297C0.0579688 18.2452 0 19.1158 0 20C0 20.8841 0.0579688 21.7547 0.169297 22.6087H10.4347H10.4348V37.5681C12.0516 38.4503 13.8039 39.1147 15.6522 39.5245V22.6089V22.6087H39.8307C39.9419 21.7547 40 20.8841 40 20C40 19.1158 39.9419 18.2452 39.8307 17.3913V17.3913Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorway);
export default __webpack_public_path__ + "static/media/norway.c33eb0dee36b90816ccf9e4aff3cb6f4.svg";
export { ForwardRef as ReactComponent };